module.exports = __webpack_public_path__ + "img/blue-box.1adc1580.svg";